import classes from "./OrderSummary.module.css"

import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { useDispatch, useSelector } from "react-redux"
import PrimaryButton from "../../../Components/Buttons/PrimaryButton/PrimaryButton"
import { fetchAllCartItems } from "../../../Store/actions/CartAction"
import { getChangedCurrencyValue } from "../../../Store/actions/UsersActions"
import { useState, useEffect } from "react";

const OrderSummary = ({ disabled, onClick }) => {
    const { cartItems, cart } = useSelector(state => state.cart);
    const currentUser = useSelector((state) => state.user.currentUser);
    const updatedCartItems = cartItems?.filter((item) => item?.book?.isDeleted === false || item?.bestSellerBook?.isDeleted === false);
    const [boxWrappingPrice, setBoxWrappingPrice] = useState(0);
    const [giftWrappingPrice, setGiftWrappingPrice] = useState(0);

    useEffect(() => {
        const calculateWrappingPrices = async () => {
            // Guard against undefined or null updatedCartItems
            if (!updatedCartItems || !Array.isArray(updatedCartItems)) {
                setBoxWrappingPrice(0);
                setGiftWrappingPrice(0);
                return;
            }
    
            const boxPrice = await Promise.all(
                updatedCartItems.map(async (ele) => {
                    return ele.boxWrapping ? await getChangedCurrencyValue(15, currentUser?.preferredCurrency) : 0;
                })
            );
            const giftPrice = await Promise.all(
                updatedCartItems.map(async (ele) => {
                    return ele.giftWrapping ? await getChangedCurrencyValue(15, currentUser?.preferredCurrency) : 0;
                })
            );
    
            setBoxWrappingPrice(boxPrice.reduce((acc, val) => acc + val, 0));
            setGiftWrappingPrice(giftPrice.reduce((acc, val) => acc + val, 0));
        };
    
        calculateWrappingPrices();
    }, [updatedCartItems, currentUser?.preferredCurrency]);

    const getShippingPrice = () => {
        let shippingSpeed = 0;
        updatedCartItems?.forEach(ele => {
            const price = ele.shippingCharges.find((e) => e.shippingSpeed === ele.shippingSpeed)?.totalAmount;
            if (price) {
                shippingSpeed += price;
            }
        });
        return shippingSpeed;
    };

    const subTotal = updatedCartItems?.reduce((acc, ele) => {
        return acc + ((ele.itemPrice + ele.customizationCharges) * ele.quantity);
    }, 0);

    const getTotal = () => {
        const itemTotal = updatedCartItems?.reduce((acc, ele) => {
            return acc + ((ele.itemPrice + ele.customizationCharges) * ele.quantity);
        }, 0);

        let totalWithDiscount = itemTotal - cart?.totalDiscount;
        if (totalWithDiscount <= 0) {
            return Number(boxWrappingPrice + giftWrappingPrice + getShippingPrice()).toFixed(2);
        } else {
            return Number(totalWithDiscount + boxWrappingPrice + giftWrappingPrice + getShippingPrice()).toFixed(2);
        }
    };

    const selectedCurrency = currentUser?.preferredCurrency || "USD";

    return (
        <div className={classes.mainContainer}>
            <h1>Order Summary</h1>
            <div className={classes.summarySection}>
                <div className={classes.overview}>
                    <h2>{cartItems?.length} Total {cartItems?.length === 1 ? "Item" : "Items"}</h2>
                </div>
                <div className={classes.priceSection}>
                    <div className={classes.subTotal}>
                        <h2>Sub-total</h2>
                        <p>{`${selectedCurrency} ${(subTotal || 0).toFixed(2)}`}</p>
                    </div>
                    {boxWrappingPrice > 0 && (
                        <div className={classes.shipping}>
                            <h2>Box-Wrapping</h2>
                            <p>{`${selectedCurrency} ${Number(boxWrappingPrice).toFixed(2)}`}</p>
                        </div>
                    )}
                    {giftWrappingPrice > 0 && (
                        <div className={classes.shipping}>
                            <h2>Gift-Wrapping</h2>
                            <p>{`${selectedCurrency} ${Number(giftWrappingPrice).toFixed(2)}`}</p>
                        </div>
                    )}
                    <div className={classes.shipping}>
                        <h2>Shipping</h2>
                        <p>{`${selectedCurrency} ${Number(getShippingPrice()).toFixed(2)}`}</p>
                    </div>
                    <div className={classes.Discount}>
                        <h2>Discount</h2>
                        <p>{`${selectedCurrency} ${Number(cart?.totalDiscount || 0).toFixed(2)}`}</p>
                    </div>
                </div>
                <div className={classes.total}>
                    <h2>Total</h2>
                    <p>{`${selectedCurrency} ${getTotal()}`}</p>
                </div>
            </div>
            <PrimaryButton disabled={disabled} onClick={onClick}>
                Proceed to Payment <span style={{ marginLeft: '8px' }}>➡</span>
            </PrimaryButton>
        </div>
    );
};

export default OrderSummary;